import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import 'chosen-js/chosen.css';
import chosen from 'chosen-js/chosen.jquery';
import 'datatables.net-rowgroup-dt/css/rowGroup.dataTables.min.css'

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

require( 'datatables.net-rowgroup-dt/js/rowGroup.dataTables.min');

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../config');

class AnaliticalTestStats extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.checking = this.checking.bind(this);
		this.getConvokePlace = this.getConvokePlace.bind(this);
		this.getDonationsType = this.getDonationsType.bind(this);
		this.setTable = this.setTable.bind(this);
		this.dateCompate = this.dateCompare.bind(this);

		this.state = {
			health_facilities_id:"",
			health_facilities: [],

			extraction_type_id:"all",
			extraction_type:[],

			donation_type_id:"all",
			donations_type:[],

			lab_sections_id:["all"],
			lab_sections:[],

			start_date 	: "",
			end_date 	: "",
			start_folio:"",
			end_folio:"",

			convoke_places:[],
			convoke_places_id:"all",

			table_list:[],
			listado:[],
			listado_pdf:[],

			change_check: false,

			//test datatable to export
			columns:[
				{title:'PRUEBA', width:'15%'},
				{title:'TIPO'},
				{title:''},
				{title:'HOMBRES', width:'10%'},
				{title:'MUJERES', width:'10%'},
				{title:'TOTAL', width:'10%'}
			],
			filename:"Estadistica de Pruebas Analiticas",
			search_type:"date",

			options: [],
			option:"",

			extraction_type_name:"",
			convoke_places_name:"",
			lab_section_name:"",
			donation_type_name:"",
			date_hour:"",
			medical:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		
		this.$select = $(this.select);
		this.$select.chosen();
		this.$select.on('change', this.handleChange);

		fetch(Config.default.apiGateway.URL+'health_facilities', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					health_facilities: response
				});
			}
		});

		this.getConvokePlace();

		fetch(Config.default.apiGateway.URL+'donation_type_extraction', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					extraction_type: response
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date_hour:aux[0]+' '+hours,
			});
		})

		this.getDonationsType();

		this.getLabSection();

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){
		this.$select.trigger("chosen:updated");
		
		var fechas = "Información Del: "+moment(this.state.start_date).format("DD/MM/YYYY")+ 
					" Al: "+moment(this.state.end_date).format("DD/MM/YYYY")
		this.$el = $(this.el);
		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdf',
                	title: this.state.filename,
                	orientation:'landscape',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						if(this.state.search_type === 'date'){
							doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });
						}

						doc.content.splice(3, 0, {
							columns:[
								this.state.convoke_places_id !== "all" ?
									{text: 'Lugar de Colecta', width:'12%', fontSize:6.5}
								: {text:"", width:0},
								this.state.convoke_places_id !== "all" ?
									{text: this.state.convoke_places_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},

								this.state.extraction_type_id !== "all" ?
									{text: 'Extracción', width:'8%', fontSize:6.5}
								: {text:"", width:0},
								this.state.extraction_type_id !== "all" ?
									{text: this.state.extraction_type_name, bold:1, margin:[0,0,0,10], fontSize:6.5}
								: {text:"", width:0},

								this.state.donation_type_id !== "all" ?
									{text: 'Donación', width:'8%', fontSize:6.5}
								: {text:"", width:0},
								this.state.donation_type_id !== "all" ?
									{text: this.state.donation_type_name, bold:1, margin:[0,0,0,10], fontSize:6.5}
								: {text:"", width:0},

								this.state.lab_section_name !== "" ?
									{text: 'Seccion Laboratorio', width:'12%', fontSize:6.5}
								: {text:"", width:0},
								this.state.lab_section_name !== "all" ?
									{text: this.state.lab_section_name, bold:1, margin:[0,0,0,10], fontSize:6.5}
								: {text:"", width:0},

							]
						});

						doc.content[4].table.body = this.state.listado_pdf
					
                		doc.styles.tableBodyOdd.fillColor = "#FFF";
                		doc.content[4].table.widths=["40%","20%","20%","20%"];
                		doc.defaultStyle.fontSize = 12; 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	}
            ],
			rowGroup: {
	            dataSrc: [ 0, 1 ],
	            startRender: function ( rows, group ) {	
	     			if(rows.data()[0][0] === group){
		     			return $('<tr/>')
		                    .append( '<td colspan="4">'+group+'</td>' );
	     			}else{
	     				var subhead = $('<tr/>')
		                    			.append( '<td style="background:#e5e5e5;font-weight:bold;font-size:14px;">'+group+'</td>' )
	     				rows.data().map((d)=>{
	     					d.map((v, i)=>{
	     						if(d[2] === 'TOTAL' && i > 2){
	     							subhead.append( '<td style="padding:8px;background:#e5e5e5;font-weight:bold;font-size:14px;text-align:right">'+v+'</td>' );
	     						}
	     					})
	     				})

	     				return subhead;
		                    
	     			}
	            	
	            },
	        },
	        columnDefs: [ {
	            targets: [ 1, 0 ],
	            visible: false
	        },{
		        targets: [3,4,5],
		        className: 'dt-right'
    		} ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sLengthMenu":"Mostrar _MENU_ registros",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfo":"Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered":"(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"oPaginate":{
					"sFirst":"Primero",
					"sLast":"Último",
					"sNext":"Siguiente",
					"sPrevious":"Anterior"},
					"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			ordering:false,
			info:false,
			
			createdRow: function(row, data, dataIndex){
				$('td:eq(0)', row).attr('style', 'padding-left:4%;');
				
				if(data[2]==='TOTAL'){
					$('td', row).attr('style', 'display:none;');
				}
			}
		});
		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		if(e.target.name === 'lab_sections_id'){
			var options = e.target.options;
			var value = [];
			var name = "";
			for (var i = 0, l = options.length; i < l; i++) {
			    if (options[i].selected) {
			    	if(options[i].value === 'all'){
			    		value = [];
			    		value.push(options[i].value);
			    		break;
			    		
			    	}else{
			    		value.push(parseInt(options[i].value));
			    		name += options[i].text + ', '
			    	}
			      
			    }
			}

			this.setState({
				[e.target.name]: value,
				lab_section_name:name.substring(0,name.length-2)
			});

			this.$select.val(value).trigger("chosen:updated");
		}else{
			this.setState({
				[e.target.name]: e.target.value
			});
		}

			

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}

		if(e.target.name === 'health_facilities_id'){
			setTimeout(()=>{
				this.getConvokePlace();
				this.getLabSection();
			}, 500);
				
		}else if(e.target.name === 'search_type'){
			this.setState({
				start_date 	: "",
				end_date 	: "",
				start_folio:"",
				end_folio:"",
			})
		}else if(e.target.name === 'convoke_places_id'){
			this.setState({
				convoke_places_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'extraction_type_id'){
			this.setState({
				extraction_type_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'donation_type_id'){
			this.setState({
				donation_type_name: e.target.options[e.target.selectedIndex].text
			})
		}
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompate()){
				this.props.waiting.handleShow('Buscando...');

				var sections = [];
				if(this.state.lab_sections_id[0] === 'all'){
					this.state.lab_sections.map((l)=>{
						return sections.push(l.id);
					});
				}else{
					sections = this.state.lab_sections_id;
				}
					

				var obj = {
					convoke_places_id: this.state.convoke_places_id,
					start_date: this.state.start_date,
					end_date: this.state.end_date,
					start_folio: this.state.start_folio,
					end_folio: this.state.end_folio,
					extraction_type_id: this.state.extraction_type_id,
					lab_section_ids: sections,
					search_by: this.state.search_type,
					donation_type_id:this.state.donation_type_id,
					option: this.state.option,
					health_facilities_id:this.state.health_facilities_id
				}
				
				fetch(Config.default.apiGateway.URL+'reports/lab_section_stats',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					
					if(res.ok){
						return res.json();
					}else{
						this.props.waiting.handleClose();
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.setState({
							listado: [],
						});

						var list = [];
						var list_pdf = [];

						response.res.map((r)=>{
							
							r.tests.map((t)=>{
								t.results.map((i)=>{
									var obj = []
									obj.push(r.name, t.name, i.result, i.men, i.women, i.total)

									list.push(obj);
								})
								
								list.push([r.name,t.name,'TOTAL',t.total_men, t.total_women, t.total]);
							})

							list_pdf.push([{text:r.name,colSpan:4,bold:1,fillColor:'#e0e0e0'}]);

							r.tests.map((t)=>{
								list_pdf.push([
									{text:t.name,bold:1,fillColor:'#f0f0f0',margin:[10,0,0,0]},
									{text:t.total_men,bold:1,fillColor:'#f0f0f0',alignment: 'right'},
									{text:t.total_women,bold:1,fillColor:'#f0f0f0',alignment: 'right'}, 
									{text:t.total,bold:1,fillColor:'#f0f0f0',alignment: 'right'}
								]);

								t.results.map((i)=>{
									list_pdf.push([
										{text:i.result, margin:[20,0,0,0]}, 
										{text:i.men, alignment: 'right'}, 
										{text:i.women, alignment: 'right'}, 
										{text:i.total, alignment: 'right'}
									])
								})
							})

							

						});

						var head = []
						this.state.columns.map((c, i)=>{
							if(i > 1){
								head.push({text:c.title, style:'tableHeader', alignment:'right'})
							}
							
						})
						list_pdf.unshift(head);

						this.setState({listado:list, listado_pdf:list_pdf});

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);
					
							
						this.props.waiting.handleClose();
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;
		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}
		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	checking(e){
		if(this.state.change_check){
			this.setState({
				change_check: false,
				health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			});
		}else{
			this.setState({
				change_check: true,
			});
		}
	}

 	getConvokePlace(){
 		var health = this.state.health_facilities_id;
 		
 		if(sessionStorage.getItem('matriz') === '1' && health === sessionStorage.getItem('health_facilities_id')){
 			health = 'all';
 		}

 		fetch(Config.default.apiGateway.URL+'convoke_places/by_hf?health_facilities_id='+health, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					convoke_places: response
				});
			}
		});
 	}

 	getDonationsType(){
 		fetch(Config.default.apiGateway.URL+'donation_type/actives', {
 			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
 		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					donations_type: response
				});
			}
		});
 	}

 	getLabSection(){
 		fetch(Config.default.apiGateway.URL+'lab_sections/by_health_facility?id='+this.state.health_facilities_id, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){

				this.setState({
					lab_sections: response
				});

				this.$select.trigger("chosen:updated");
			}
		});
 	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Laboratorio ->
					{t('sidebar.nav.reports.analitical_test_stats')}
					</h5>
				</div>
				
				<Help 
					{...this.props}
		            menu={"help_donors"} 
		            submenu={"help_analitical_test_stats"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Centro</span>
									<select type="text" name="health_facilities_id" id="health_facilities_id" 
										value={this.state.health_facilities_id} disabled={!this.state.change_check} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.health_facilities.map((h, i)=>{
											return <option key={i} value={h.id}>
												{h.name}
											</option>
										})}
									</select>

									<input type="checkbox" name="change_center" id="change_center" 
										style={{marginRight:"5px"}} onChange={this.checking}
										checked={this.state.change_check} />
									<span className="span-min">Cambiar</span>
								</div>
								<div className="form-group">
									<span className="span-min">Lugar de Colecta</span>
									<select className="form-control" name="convoke_places_id" id="convoke_places_id"
										value={this.state.convoke_places_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.convoke_places.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Tipo de Busqueda</span>
									<select className="form-control" name="search_type" id="search_type"
										value={this.state.search_type} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="date">Fecha</option>
										<option value="folio">Folio</option>
									</select>
								</div>
								{this.state.search_type === 'date' ?
									<div>
										<div className="form-group">
											<span className="span-min">Fecha Desde</span>
											<input type="date" className="form-control hour-input" name="start_date" id="start_date"
												value={this.state.start_date} onChange={this.handleChange} required  />
										</div>
										<div className="form-group">
											<span className="span-min">Fecha Hasta</span>
											<input type="date" className="form-control hour-input" name="end_date" id="end_date"
												value={this.state.end_date} onChange={this.handleChange} required />
										</div>
									</div>
								: <div className="form-group">
									<div className="col-xs-12 col-sm-6 form-group" style={{paddingLeft:"0"}}>
										<span className="span-min">Folio Desde</span>
										<input type="text" className="form-control"  name="start_folio" id="start_folio"
											value={this.state.start_folio} onChange={this.handleChange} />
									</div>
									<div className="col-xs-12 col-sm-6 form-group" style={{paddingRight:"0"}}>
										<span className="span-min">Folio Hasta</span>
										<input type="text" className="form-control" name="end_folio" id="end_folio"
											value={this.state.end_folio} onChange={this.handleChange} />
									</div>
								</div>
								}
									
								<div className="form-group">
									<span className="span-min">Tipo de Extracción</span>
									<select className="form-control" name="extraction_type_id" id="extraction_type_id"
										value={this.state.extraction_type_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.extraction_type.map((don, i)=>{
											return <option key={i} value={don.donation_type_extraction.id}>
												{don.lookup_value}
											</option>
										})}
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Tipo de Donación</span>
									<select className="form-control"  name="donation_type_id" id="donation_type_id"
										value={this.state.donation_type_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.donations_type.map((d, i)=>{
											return <option key={i} value={d.donation_type.id}>
												{d.lookup_value}
											</option>
										})}
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Mostrar</span>
									<select className="form-control"  name="option" id="option"
										value={this.state.option} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="only_test">SÓLO TOTAL DE PRUEBAS</option>
										<option value="test_and_results">TOTAL DE PRUEBAS Y RESULTADOS</option>
									</select>
								</div>
								<div className="form-group">
									<span className="span-min col-xs-12" style={{width:'100%'}}>Sección Laboratorio</span>
									<select className="form-control"  name="lab_sections_id" id="lab_sections_id"
										value={this.state.lab_sections_id} 
										multiple={true} required data-placeholder={'Seleccione...'}
										ref={el => this.select = el}>
										<option value="all">TODOS</option>
										{this.state.lab_sections.map((l, i)=>{
											return <option key={i} value={l.id}>
												{l.name}
											</option>
										})}
									</select>
									
								</div>
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline",fontSize:'16px'}}>
										<span>
											Estadistica de Pruebas Analiticas
										</span>
									</div>
								</div>
								{this.state.search_type === 'date' ?
									<div className="col-xs-12" >
										<span>
											Información Del:   {this.state.start_date !== "" ? 
												moment(this.state.start_date).format('DD/MM/YYYY')
											:'  '}
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: {this.state.end_date !== "" ? 
												moment(this.state.end_date).format('DD/MM/YYYY')
											:'  '}
										</span>
									</div>
								: null}

								<div className="col-xs-12">
									{this.state.convoke_places_id !== 'all' && this.state.convoke_places_id !== ""?
										<span>
											Lugar de Colecta:  
											<b style={{marginLeft:"5px"}}>{this.state.convoke_places_name}</b>
										</span>	
									:null}

									{this.state.extraction_type_id !== 'all' && this.state.extraction_type_id !== ""?
										<span style={{marginLeft:"15px"}}>
											Extracción: 
											<b style={{marginLeft:"5px"}}>{this.state.extraction_type_name}</b>
										</span>	
									:null}

									{this.state.donation_type_id !== 'all' && this.state.donation_type_id !== "" ?
										<span style={{marginLeft:"15px"}}>
											Donacion:  
											<b style={{marginLeft:"5px"}}>{this.state.donation_type_name}</b>
										</span>	
									:null}

									{this.state.lab_sections_id[0] !== 'all' && this.state.lab_sections_id[0] !== "" && this.state.lab_section_name !== "" ?
										<span style={{marginLeft:"15px"}}>
											Secciones Laboratorio: 
											<b style={{marginLeft:"5px"}}>{this.state.lab_section_name}</b>
										</span>
									:null}
								</div>
								

								<div className="col-xs-12" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className={"table table-striped"} id="table-to-xls" 
											width="100%" ref={el => this.el = el}>
										</table>
									</div>

								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (AnaliticalTestStats);